import { batch, useDispatch } from "react-redux";
import { useLanguage } from "../languages";
import { useCommandBar } from "../layout";
import { layoutSlice } from "../slices";
export const useLayout = () => {
    const dispatch = useDispatch();
    const lang = useLanguage();
    const commandBar = useCommandBar();
    return {
        clearCommandBarFarItems: () => commandBar.clearFarItems(),
        clearCommandBarItems: () => commandBar.clearItems(),
        hideSearchBox: () => dispatch(layoutSlice.actions.setShowSearchBox(false)),
        resetSearchBox: () => dispatch(layoutSlice.actions.setSearch('')),
        setCommandBarFarItems: (items) => commandBar.setFarItems(items),
        setCommandBarItems: (items) => commandBar.setItems(items),
        setMessage: (message) => dispatch(layoutSlice.actions.setMessage(message)),
        setSearchBoxValue: (search) => dispatch(layoutSlice.actions.setSearch(search)),
        setTheme: (theme) => dispatch(layoutSlice.actions.setThemeName(theme !== null && theme !== void 0 ? theme : 'light')),
        showSearchBox: (placeholder) => {
            batch(() => {
                var _a;
                dispatch(layoutSlice.actions.setShowSearchBox(true));
                dispatch(layoutSlice.actions.setSearch(''));
                dispatch(layoutSlice.actions.setSearchBoxPlaceholder((_a = placeholder !== null && placeholder !== void 0 ? placeholder : lang.search) !== null && _a !== void 0 ? _a : 'Search...'));
            });
        },
        setNotifications: (notifications) => dispatch(layoutSlice.actions.setNotifications(notifications)),
    };
};
